import React from "react";
import { useNavigate } from "react-router-dom";
import LoanSteps from "./Loansteps";
import CallToAction from "./CallToAction";

const IndustrialLoanInfo = () => {
    const navigate = useNavigate();

    return (
        <>
            <div className="other-pages-main-section industrial-fin">
                <h2 className="other-pages-title">Industrial Loan</h2>
                <p>
                    <span onClick={() => navigate("/")} style={{ cursor: "pointer" }}>Home</span> /
                    <span onClick={() => navigate("/industrial-loan-mumbai-thane-palghar-maharashtra-delhi-india")} style={{ cursor: "pointer" }}>Industrial Loan</span>
                </p>
            </div>
            <div className="info-loan-card-smco">
                <h2 className="info-loan-title-smco">What is an Industrial Loan?</h2>

                <p className="info-loan-description-smco">
                    An industrial loan is a specialized financing solution designed for businesses in the manufacturing, processing, and industrial sectors. These loans provide the necessary capital for purchasing machinery, equipment, raw materials, or expanding production facilities. Offered by banks, NBFCs, and financial institutions, industrial loans help industries scale operations, modernize infrastructure, and meet growing market demands.
                    <br /><br />
                    Lenders evaluate factors such as the business's financial health, project viability, and industry outlook before approval. Loan amounts can vary widely, from lakhs to crores, depending on the scale of the project. Repayment tenures typically range from 3 to 10 years, with options for moratorium periods during the initial setup phase.
                    <br /><br />
                    Interest rates for industrial loans generally fall between 10% to 20% per annum, influenced by the borrower's credit profile, project risk, and prevailing market rates. Additional charges may include processing fees, appraisal fees, and legal costs. Fixed or floating rate options are available to suit different risk appetites.
                    <br /><br />
                    Industrial loans are crucial for sectors like manufacturing, textiles, chemicals, and engineering, enabling businesses to invest in technology upgrades, capacity expansion, and sustainable practices. Proper planning and feasibility studies are essential to ensure the loan aligns with business goals and repayment capabilities.
                </p>

                <div className="info-section-smco">
                    <h3 className="info-section-title-smco">Key Features of an Industrial Loan</h3>
                    <ul className="info-feature-list-smco">
                        <li><strong>Project-specific financing:</strong> Tailored to fund specific industrial projects, machinery, or infrastructure.</li>
                        <li><strong>Large loan amounts:</strong> Suitable for high-value investments, often ranging from ₹50 lakhs to ₹10 crores or more.</li>
                        <li><strong>Flexible tenures:</strong> Repayment periods from 3 to 10 years, with possible grace periods for project implementation.</li>
                        <li><strong>Collateral options:</strong> Secured against assets like machinery, land, or future receivables.</li>
                        <li><strong>Subsidies and incentives:</strong> May qualify for government subsidies or lower rates under industrial development schemes.</li>
                        <li><strong>Tax benefits:</strong> Interest payments are often deductible as business expenses.</li>
                    </ul>
                </div>

                <div className="info-section-smco">
                    <h3 className="info-section-title-smco">Eligibility Criteria</h3>
                    <ul className="info-eligibility-list-smco">
                        <li><strong>Business type:</strong> Manufacturing, processing, or industrial enterprises.</li>
                        <li><strong>Business age:</strong> Typically 2–5 years of operational history.</li>
                        <li><strong>Annual turnover:</strong> Minimum turnover of ₹1 crore or more, depending on the lender.</li>
                        <li><strong>Credit score:</strong> Strong credit profile for the business and promoters, usually above 700.</li>
                        <li><strong>Project viability:</strong> Detailed project reports, financial projections, and feasibility studies.</li>
                        <li><strong>Legal documents:</strong> Business registration, PAN, GST filings, and collateral documents.</li>
                    </ul>
                </div>

                <div className="info-section-smco">
                    <h3 className="info-section-title-smco">Interest Rates and Charges</h3>
                    <p>
                        Interest rates range from 10% to 20% per annum, based on risk assessment and market conditions. Additional costs include processing fees (1%–2%), legal and valuation charges, and prepayment penalties. Some lenders offer concessional rates for priority sectors or under government schemes.
                    </p>
                </div>

                <div className="info-section-smco">
                    <h3 className="info-section-title-smco">Benefits of Industrial Loans</h3>
                    <ul className="info-benefits-list-smco">
                        <li><strong>Capacity expansion:</strong> Funds for scaling production and meeting increased demand.</li>
                        <li><strong>Technology upgrade:</strong> Invest in modern machinery and automation for efficiency.</li>
                        <li><strong>Job creation:</strong> Support industrial growth and employment opportunities.</li>
                        <li><strong>Government support:</strong> Access to subsidies and incentives for industrial development.</li>
                        <li><strong>Long-term growth:</strong> Build a stronger industrial base for sustained profitability.</li>
                    </ul>
                </div>
            </div>
            <LoanSteps />
            <CallToAction />
        </>
    );
};

export default IndustrialLoanInfo;
